__turbopack_context__.v({
  "container": "Impressum-module__kJEmBG__container",
  "line": "Impressum-module__kJEmBG__line",
  "section": "Impressum-module__kJEmBG__section",
  "sectionTitle": "Impressum-module__kJEmBG__sectionTitle",
});
